import type { Timestamp } from 'firebase/firestore';
import type { CompanyRole, ModulePermissions } from './Role';

export type ExpirationPeriod = '1h' | '12h' | '1d' | '7d' | '30d' | 'never';

/** Horas de vida de cada periodo, para calcular el vencimiento del enlace. */
export const EXPIRATION_HOURS: Record<ExpirationPeriod, number> = {
  '1h': 1,
  '12h': 12,
  '1d': 24,
  '7d': 24 * 7,
  '30d': 24 * 30,
  never: Infinity
};

/** Un enlace que otorga rol de admin no puede vivir mucho tiempo. */
export const ADMIN_EXPIRATION_PERIODS: readonly ExpirationPeriod[] = ['1h', '12h', '1d'];

export interface ShareLinkData {
  expiration: ExpirationPeriod;
  role: CompanyRole;
  /** Permisos con los que entra el invitado; solo aplica al rol regular. */
  permissions?: ModulePermissions;
  /** Rol personalizado con el que entra el invitado; implica role 'regular'. */
  customRoleId?: string;
  createdBy: string | undefined;
}

export interface InviteData {
  companyId: string;
  role: CompanyRole;
  permissions?: ModulePermissions;
  /** Rol personalizado con el que entra el invitado; implica role 'regular'. */
  customRoleId?: string;
  inviteId?: string;
}

export interface CompanyInvite {
  companyId: string;
  expiration: string;
  createdAt: Timestamp;
  createdBy: string | undefined;
} 

export interface CompanyRef {
  id: string;
  name: string;
  planRef?: {
    id: string;
    name: string;
    type: string;
  };
  membersCount?: number;
}

export interface CompanyPlan {
  id: string;
  name: string;
  type: string;
  features: string[];
  limits: {
    users: number;
    storage: number;
    [key: string]: any;
  };
}

export type OperationType = 'importer' | 'forwarder';

export interface CompanyData {
  id: string;
  unlimitedShipments?: boolean;
  operationType?: OperationType;
  /** Dominios de correo que pueden entrar a la compañía; vacío = sin restricción. */
  allowedEmailDomains?: string[];
  [key: string]: any;
}

export type ClientType = 'regular' | 'view';
